import React, { useState, useCallback, useEffect } from 'react'
import {
  Grid,
  Typography,
  Breadcrumbs,
  Link,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormControlLabel,
  Pagination,
} from '@mui/material'
import useStyles from './style'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { numberToIndianRupee } from 'utils/numberToIndianRupee'
import { useUrlSearchParams } from 'utils/hooks'
import productsApi from 'services/products'
import { showLoader, hideLoader } from 'redux/loader/actions'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import _ from 'lodash'
import { API_ENDPOINTS } from 'constants'
import { useNavigate } from 'react-router-dom'

const SearchProductsListing = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [paginationParams, setPaginationParams] = useState({
    page: 1,
    limit: 10,
  })
  const [productsList, setProductsList] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalProducts, setTotalProducts] = useState(0)
  const [pageQuery, setPageQuery] = useUrlSearchParams(
    {
      search: '',
    },
    {
      search: String,
    }
  )
  const { search } = pageQuery
  const [searchParams, setSearchParams] = useState({
    search: null,
    page: 1,
    limit: 10,
  })

  // Handle pagination
  const handlePagination = (event, value) => {
    if (typeof value === 'number') {
      setCurrentPage(value)
      //   setPageQuery({ ...pageQuery, page: value })
      setSearchParams({ ...searchParams, page: value })
    }
  }

  // handle products search
  const handleProductsSearch = useCallback(() => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        setProductsList(res?.data?.data)
        setTotalProducts(res?.data?.totalItems || 0)
      } else {
        setProductsList([])
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      console.log('Get products list from search Api', err)
    }
    productsApi.searchProducts(searchParams).then(onSuccess, onFailure)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams])
  useEffect(() => {
    searchParams?.search?.length > 2 && handleProductsSearch()
  }, [handleProductsSearch, searchParams])

  // Set Search page query on page query change
  useEffect(() => {
    setSearchParams({ ...searchParams, search: search })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search])

  return (
    <>
      <Grid container className={classes.root}>
        {/* Breadcrumbs */}
        <Grid item xs={12}>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Typography variant="body1">Jewellery</Typography>
          </Breadcrumbs>
        </Grid>
        <Grid item xs={12} className={classes.searchWrapper}>
          <div className={classes.title}>
            <Typography variant="h5">
              Jewellery | {productsList?.length} Designs
            </Typography>
          </div>
        </Grid>

        {/* Filters && Products */}
        <Grid item xs={12} className={classes.wrapper}>
          <Grid item xs={12} className={classes.productsContainer}>
            {!_.isEmpty(productsList) ? (
              <>
                <Grid item xs={12} className={classes.productsWrapper}>
                  {productsList?.map((data) => (
                    <Grid
                      item
                      xs={6}
                      sm={6}
                      md={4}
                      lg={3}
                      className={classes.productSpacing}
                      key={data?.id}
                    >
                      <section
                        className={classes.productCard}
                        onClick={() => navigate(`/product/${data?._id}`)}
                      >
                        <div className={classes.imgWrapper}>
                          <img
                            src={
                              API_ENDPOINTS.FILE_URL +
                              data?.image?.[0]?.filename
                            }
                            alt={data?.title}
                            className={classes.productImg}
                          />{' '}
                        </div>
                        <div className={classes.productDetail}>
                          <Typography
                            variant="body1"
                            className={classes.productLabel}
                          >
                            <strong>
                              {data?.name}
                              {/* &#x20b9; {numberToIndianRupee(data?.price)} */}
                            </strong>
                            {/* {data?.metalDiscount !== 0 && (
                          <span className={classes.discount}>
                            ({data?.metalDiscount}% OFF)
                          </span>
                        )} */}
                          </Typography>
                        </div>
                      </section>
                    </Grid>
                  ))}
                </Grid>
                {/* Pagination */}
                {totalProducts < 11 ? (
                  <></>
                ) : (
                  <Grid item xs={12} className={classes.pagination}>
                    <section>
                      <Typography variant="body1">
                        Page {currentPage} of{' '}
                        {Math.ceil(totalProducts / paginationParams.limit)}
                      </Typography>
                    </section>
                    <Pagination
                      count={Math.ceil(totalProducts / paginationParams.limit)}
                      page={currentPage}
                      onChange={handlePagination}
                      color="secondary"
                      shape="rounded"
                    />
                  </Grid>
                )}
              </>
            ) : (
              <>
                <section className={classes.noDataWrapper}>
                  <img
                    src="/assets/images/notfound1.png"
                    alt="No data"
                    className={classes.notFoundImg}
                  />
                  <Typography variant="h6">
                    We can't find products matching the selection <br /> Try
                    different filters !
                  </Typography>
                </section>
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default SearchProductsListing
